module.exports = __webpack_public_path__ + "img/entrepreneur.8d03e89c.jpg";